import { profile } from "../../data/resume";

function Contact() {
    const year = new Date().getFullYear();

    return (
        <footer id="contact" className="contact-footer">
            <div className="container">
                <div className="section-header">
                    <p className="section-eyebrow">Get in touch</p>
                    <h2 className="section-title">Let's Connect</h2>
                </div>
                <p className="contact-lead">
                    I'm always open to discussing new opportunities, interesting projects, or ways to collaborate.
                </p>
                <div className="contact-links">
                    <a className="contact-link" href={`mailto:${profile.email}`}>
                        <img src="/icons/icons8-gmail-login-100.png" alt="" />
                        {profile.email}
                    </a>
                    <a className="contact-link" href={profile.github} target="_blank" rel="noreferrer">
                        <img src="/icons/icons8-github-100.png" alt="" />
                        GitHub
                    </a>
                    <a className="contact-link" href={profile.linkedin} target="_blank" rel="noreferrer">
                        <img src="/icons/icons8-linkedin-100.png" alt="" />
                        LinkedIn
                    </a>
                </div>
                <p className="footer-copy">© {year} {profile.name}. Built with React.</p>
            </div>
        </footer>
    );
}

export default Contact;
